import { faBan, faEllipsisVertical } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@shared/components/ui/shadcn/dropdown-menu';
import { useTranslation } from 'react-i18next';
import { EligibleStorage } from '../../models/EligibleStorage';

type ActionType = 'removeFromPreinvoice' | 'block';

interface EligibleStorageDropdownActionsProps {
  storage: EligibleStorage;
  onAction: (action: ActionType, storage: EligibleStorage) => void;
}

export const EligibleStorageDropdownActions = ({
  storage,
  onAction,
}: EligibleStorageDropdownActionsProps) => {
  const { t } = useTranslation('eligibleStorageModule');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="p-2 hover:bg-gray-100 rounded-full transition-colors">
          <FontAwesomeIcon
            icon={faEllipsisVertical}
            className="w-4 h-4 text-gray-500"
          />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem
          onClick={() => onAction('block', storage)}
          className="cursor-pointer"
        >
          <FontAwesomeIcon icon={faBan} className="mr-1 !w-3 !h-3 !text-content-primary" />
          {t('actions.block', 'Bloquear')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
